"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsoredProjects = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var SponsoredProjects = (function () {
    function SponsoredProjects() {
        this.name = GlobalEventName_1.GlobalEventName.SPONSORED_PROJECTS;
        this.description = 'All cards with resources on them gain 1 resource. Draw 1 card for each influence.';
        this.revealedDelegate = PartyName_1.PartyName.SCIENTISTS;
        this.currentDelegate = PartyName_1.PartyName.GREENS;
    }
    SponsoredProjects.prototype.resolve = function (game, turmoil) {
        game.getPlayers().forEach(function (player) {
            player.getCardsWithResources().forEach(function (card) { return card.resourceCount && player.addResourceTo(card); });
            player.drawCard(turmoil.getPlayerInfluence(player));
        });
    };
    return SponsoredProjects;
}());
exports.SponsoredProjects = SponsoredProjects;
//# sourceMappingURL=SponsoredProjects.js.map